<button class="flex items-center justify-center" (click)="goBack()">
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.3787 3.95312L2.33203 7.99979L6.3787 12.0465" stroke="#4A4A4A" stroke-width="1.5" stroke-miterlimit="10"
      stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13.6653 8H2.44531" stroke="#4A4A4A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</button>